/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import _noop from 'lodash/noop';

export default (set, get, stackItemId, resetDropZones = _noop) => {

  resetDropZones();

  return set(produce(get(), (draft) => {
    if (!draft.design) {
      draft.design = {};
    }

    draft.design.selectedVisualizerItemStackId = stackItemId;

  }), false, { type: 'SELECT_VISUALIZER_ITEM',
    payload: {
      stackItemId,
    } });
};
